import React from "react";
import {SquareCard} from "@obby/components";

export function FeaturedBlogPosts(){
  return (
    <section className="featured-blog-posts">
      <div className="row">
        <div className="col-12 col-sm-6 col-lg-3 mb-4 pb-4">
          <SquareCard
            url="https://www.instagram.com/obbyuk/"
            thumbnail="https://res.cloudinary.com/obby/image/upload/v1627644126/Page%20Images/Obby.jpg"
            title="Instagram"
            description="Find out what workshops we are going on"
          />
        </div>
        <div className="col-12 col-sm-6 col-lg-3 mb-4 pb-4">
          <SquareCard
            url="https://blog.obby.co.uk/world-vegan-day-recipes/e"
            thumbnail="https://res.cloudinary.com/obby/image/upload/v1627644153/Page%20Images/Vegan.jpg"
            title="World Vegan Day"
            description="Obby’s Top Vegan Recipes"
          />
        </div>
        <div className="col-12 col-sm-6 col-lg-3 mb-4 pb-4">
          <SquareCard
            url="https://blog.obby.co.uk/10-top-tips-hosting-successful-class/"
            thumbnail="https://res.cloudinary.com/obby/image/upload/v1627644179/Page%20Images/TopTips.jpg"
            title="Feedback from over 500 classes"
            description="Our top 10 tips for hosting"
          />
        </div>
        <div className="col-12 col-sm-6 col-lg-3 mb-4 pb-4">
          <SquareCard
            url="https://blog.obby.co.uk/how-to-cook-an-egg/"
            thumbnail="https://res.cloudinary.com/obby/image/upload/v1627644204/Page%20Images/Egg.jpg"
            title="How to Cook an Egg"
            description="Obby's top 5 techniques that anyone can master"
          />
        </div>
      </div>
    </section>
  );
}
